import CompanyLogoPage from './CompanyLogoPage';
export { CompanyLogoPage };
export default CompanyLogoPage;
